import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "@app/store/store";

interface UserState {
  userPermissions: string[] | null;
}

const initialState: UserState = {
  userPermissions: null,
};

const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    setUserPermissions(state, action: PayloadAction<string[]>) {
      state.userPermissions = action.payload;
    },
  },
});

export const { setUserPermissions } = userSlice.actions;

export const selectUserPermissions = (state: RootState): string[] =>
  state.user.userPermissions || [];

export default userSlice.reducer;